export default {
      id: "R-usage",
      viewBox: "0 0 240 368",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#R-usage",
      toString: function () {
        return this.url;
      }
    }